'use client';

import dynamic from 'next/dynamic';

export const SelectAdTypeModalDynamic = dynamic(
  () =>
    import('@/components/SelectAdTypeModal/SelectAdTypeModal').then(
      mod => mod.SelectAdTypeModal
    ),
  { ssr: false }
);
